import { CobaltDivider } from '@cae/cobalt-react/components/divider';
import { ProfileHeader } from '@features/profile/components/header/ProfileHeader';
import { ProfileSideDesktopNavigation } from '@features/profile/components/side-navigation/ProfileSideDesktopNavigation';
import { ProfileProvider } from '@features/profile/contexts/ProfileProvider';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import styles from './ProfileLayout.module.css';

const ProfileLayout = React.memo((): React.ReactElement => {
  return (
    <ProfileProvider>
      <div className={styles.profileLayout}>
        <header className={styles.profileHeader}>
          <ProfileHeader />
        </header>

        <div className={styles.profileBody}>
          <aside className={styles.profileSideNavigation}>
            <ProfileSideDesktopNavigation />
          </aside>

          <div className={styles.profileDivider}>
            <CobaltDivider orientation="vertical" />
          </div>

          <main className={styles.profileContent}>
            <Outlet />
          </main>
        </div>
      </div>
    </ProfileProvider>
  );
});

ProfileLayout.displayName = 'ProfileLayout';

export { ProfileLayout };
